import * as React from "react";

interface PillButtonProps {
  text: string;
  className?: string;
}

export const PillButton: React.FC<PillButtonProps> = ({
  className = "",
  text,
}) => {
  return (
    <div
      className={`flex bg-light-blue hover:bg-dark-blue transition text-white rounded-[100px] w-fit px-10 py-2 ${className} `}
      role="button"
      tabIndex={0}
    >
      {text}
    </div>
  );
};

export default PillButton;
